import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/barcode-read.svg")